// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2bTUB","ranges":"BmiRanges_ranges__1wfod"};